import { render, staticRenderFns } from "./NotificationsToggle.vue?vue&type=template&id=577f00ae&scoped=true&"
import script from "./NotificationsToggle.vue?vue&type=script&lang=js&"
export * from "./NotificationsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577f00ae",
  null
  
)

export default component.exports